"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _CreateFooter = _interopRequireDefault(require("../stagedObjects/CreateFooter"));

var _CreateSmtpToken = _interopRequireDefault(require("../stagedObjects/CreateSmtpToken"));

var _CreateType = _interopRequireDefault(require("../stagedObjects/CreateType"));

var _SetBccEmailSettings = _interopRequireDefault(require("../stagedObjects/SetBccEmailSettings"));

var _UpdateDoiPages = _interopRequireDefault(require("../stagedObjects/UpdateDoiPages"));

var _UpdateDoiSettings = _interopRequireDefault(require("../stagedObjects/UpdateDoiSettings"));

var _UpdateEmailSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateEmailSiteSettings"));

var _UpdateFooter = _interopRequireDefault(require("../stagedObjects/UpdateFooter"));

var _UpdateType = _interopRequireDefault(require("../stagedObjects/UpdateType"));

var _defaultCompanyProperties = _interopRequireDefault(require("./staging/defaultCompanyProperties"));

var _defaultContactProperties = _interopRequireDefault(require("./staging/defaultContactProperties"));

var _defaultOwnerProperties = _interopRequireDefault(require("./staging/defaultOwnerProperties"));

var _default = (0, _redux.combineReducers)({
  createFooter: _CreateFooter.default.getReducer(),
  createSmtpToken: _CreateSmtpToken.default.getReducer(),
  createType: _CreateType.default.getReducer(),
  setBccEmailSettings: _SetBccEmailSettings.default.getReducer(),
  updateDoiPages: _UpdateDoiPages.default.getReducer(),
  updateDoiSettings: _UpdateDoiSettings.default.getReducer(),
  updateEmailSiteSettings: _UpdateEmailSiteSettings.default.getReducer(),
  updateFooter: _UpdateFooter.default.getReducer(),
  updateType: _UpdateType.default.getReducer(),
  defaultCompanyProperties: _defaultCompanyProperties.default,
  defaultContactProperties: _defaultContactProperties.default,
  defaultOwnerProperties: _defaultOwnerProperties.default
});

exports.default = _default;
module.exports = exports.default;